import React from 'react';

import { LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';

import { useAppSelector } from './hooks';

export function AuthorizeApiAccess() {
  const loggingIn = useAppSelector((state) => state.logInData.isAutomaticLogInOngoing);
  if (loggingIn) return null;

  const params = new URLSearchParams(window.location.search);
  const authToken = params.get('token');
  if (!authToken) throw new Error('API authorization page reached without token.');

  return (
    <LoginScreen>
      <StandardLoginScreenContents apiAuthorizationCode={authToken ?? undefined} />
    </LoginScreen>
  );
}
